import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'duotone-discount-coupon-svg-icon',
    templateUrl: 'duotone-coupon-discount-svg-icon.component.html',
    standalone: false
})

export class DuotoneCouponDiscountSvgIconComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
